import React from 'react';
import View from './View';

const AccountDetails = () => {
  return (
    <View />
  );
};

export default AccountDetails;
